// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ExplainListQueryVariables = Types.Exact<{
  databaseId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  serverId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type ExplainListQuery = {
  __typename?: "GraphqlQuery";
  getExplains: Array<{
    __typename?: "QueryExplain";
    id: string;
    humanId: string;
    fingerprint: string;
    seenAt: number;
    planNodeTypes?: Array<string | null> | null;
    totalCost?: number | null;
    totalBlkReadTime?: number | null;
    totalSharedBlksRead?: number | null;
    query: { __typename?: "Query"; id: string; truncatedQuery: string };
    querySample?: {
      __typename?: "QuerySample";
      id: string;
      runtimeMs: number;
      queryTagset?: {
        __typename?: "QueryTagset";
        id: string;
        commentData: any;
      } | null;
    } | null;
    database: { __typename?: "Database"; id: string };
    postgresRole: { __typename?: "PostgresRole"; id: string; name: string };
  }>;
  getServerDetails: {
    __typename?: "Server";
    id: string;
    humanId: string;
    name: string;
    blockSize: number;
    collectorInfo?: {
      __typename?: "CollectorInfo";
      id: string;
      logCollectionDisabled: boolean;
      logCollectionDisabledReason?: string | null;
    } | null;
  };
};

export const ExplainListDocument = gql`
  query ExplainList($databaseId: ID, $serverId: ID) {
    getExplains(databaseId: $databaseId, serverId: $serverId) {
      id
      humanId
      fingerprint
      seenAt
      planNodeTypes
      totalCost
      totalBlkReadTime
      totalSharedBlksRead
      query {
        id
        truncatedQuery
      }
      querySample {
        id
        runtimeMs
        queryTagset {
          id
          commentData
        }
      }
      database {
        id
      }
      postgresRole {
        id
        name
      }
    }
    getServerDetails(databaseId: $databaseId, serverId: $serverId) {
      id
      humanId
      name
      blockSize
      collectorInfo {
        id
        logCollectionDisabled
        logCollectionDisabledReason
      }
    }
  }
`;

/**
 * __useExplainListQuery__
 *
 * To run a query within a React component, call `useExplainListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplainListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplainListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useExplainListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExplainListQuery,
    ExplainListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplainListQuery, ExplainListQueryVariables>(
    ExplainListDocument,
    options,
  );
}
export function useExplainListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplainListQuery,
    ExplainListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplainListQuery, ExplainListQueryVariables>(
    ExplainListDocument,
    options,
  );
}
// @ts-ignore
export function useExplainListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExplainListQuery,
    ExplainListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExplainListQuery, ExplainListQueryVariables>;
export function useExplainListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplainListQuery,
        ExplainListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExplainListQuery | undefined,
  ExplainListQueryVariables
>;
export function useExplainListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplainListQuery,
        ExplainListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExplainListQuery, ExplainListQueryVariables>(
    ExplainListDocument,
    options,
  );
}
export type ExplainListQueryHookResult = ReturnType<typeof useExplainListQuery>;
export type ExplainListLazyQueryHookResult = ReturnType<
  typeof useExplainListLazyQuery
>;
export type ExplainListSuspenseQueryHookResult = ReturnType<
  typeof useExplainListSuspenseQuery
>;
export type ExplainListQueryResult = Apollo.QueryResult<
  ExplainListQuery,
  ExplainListQueryVariables
>;
